import {
  CreateBatchPieceAnnotationsRequest,
  CreatePieceAnnotationRequest,
  PieceAnnotationListResponse,
  PieceAnnotationPagedList,
  PieceAnnotationPagedListResponse,
  PieceAnnotationResponse,
  PieceAnnotationsListParams,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const pieceAnnotationApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    createPieceAnnotation: builder.mutation<PieceAnnotationResponse, CreatePieceAnnotationRequest>({
      query: (requestData) => ({
        url: '/piece/annotations',
        method: 'POST',
        body: requestData,
      }),
      invalidatesTags: ['PieceAnnotations'],
    }),
    createPieceAnnotations: builder.mutation<PieceAnnotationListResponse, CreateBatchPieceAnnotationsRequest>({
      query: (requestData) => ({
        url: '/piece/annotations/batch',
        method: 'POST',
        body: requestData,
      }),
      invalidatesTags: ['PieceAnnotations'],
    }),
    getPieceAnnotationFiltered: builder.query<PieceAnnotationPagedList, PieceAnnotationsListParams>({
      query: (params) => ({
        url: '/piece/annotations',
        params,
      }),
      providesTags: (result) => {
        const tagsList =
          result?.items?.map((annotation) => ({ type: 'PieceAnnotations' as const, id: annotation.id })) || [];

        const pieceIdTags =
          result?.items?.reduce((acc: any[], annotation) => {
            if (annotation.pieceId && !acc.some((tag) => tag.id === `piece-${annotation.pieceId}`)) {
              acc.push({ type: 'PieceAnnotations' as const, id: `piece-${annotation.pieceId}` });
            }
            return acc;
          }, []) || [];

        return ['PieceAnnotations', ...tagsList, ...pieceIdTags];
      },
      transformResponse: (response: PieceAnnotationPagedListResponse) => response.objectData,
    }),
  }),
});

export const { useCreatePieceAnnotationMutation, useGetPieceAnnotationFilteredQuery, useCreatePieceAnnotationsMutation } = pieceAnnotationApi;
